<script setup lang="ts">
import { defineProps,defineEmits } from 'vue'
const props = defineProps({  
        
    status: {
        type: Boolean,
        required: false,
    },
    progress: {
        type: String,
        required: true,
    },
    
})


</script>
<template>
   <div class="loading fixed flex a-center j-center column" :class="props.status? 'active': ''">
     
    <h2 class="white heading1 rel p-20 t-center">{{ props.progress }} %</h2>
 </div>
</template>

<style scoped>
@import '../assets/styles/frontpage.css';

.white.heading1::after{
    content: '';
    position: absolute;
    /* left: 100%; */
    animation-name: example;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;


}
@keyframes example {
  0%   {content: ''}
  25%  {content: '.'}
  50%  {content: '..'}
  100% {content: '...'}
}
</style>